import { render } from "./InvoiceDetailsGeneralInforamtion.vue?vue&type=template&id=6f15fe08&scoped=true"
import script from "./InvoiceDetailsGeneralInforamtion.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailsGeneralInforamtion.vue?vue&type=script&lang=js"

import "./InvoiceDetailsGeneralInforamtion.vue?vue&type=style&index=0&id=6f15fe08&lang=scss&scoped=true"

import exportComponent from "H:\\_LK\\workInProgress\\invoice-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f15fe08"]])

export default __exports__